import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import React from "react";
import { Controller, useForm, useFormState } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

const QCReportSelect = () => {
    const navigate = useNavigate();
    const {
        handleSubmit,
        formState: { errors },
        control,
    } = useForm();

    const { isValid } = useFormState({
        control,
    });
    const { useFetch: useFetchQCBatch } = useAPIQuery({
        key: "qc-batch-dropdown",
        endpoint: "/api/check-batch/",
    });
    const { data: batches, isLoading: batchesLoading } = useFetchQCBatch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });
    const onSubmit = (data) => {
        console.log(data);
        navigate("/qc-report", {
            state: { data: { data } },
        });
    };

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title">QC Batch Select</h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Select QC Batch
                                        <span className="fs-8 text-danger">
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={batches?.results?.data?.map(
                                                    (b) => ({
                                                        value: b?.id,
                                                        label: `${
                                                            b?.batch_code
                                                        } - ${
                                                            b?.po
                                                                ? b?.po
                                                                      ?.po_number
                                                                : b?.daily_plan
                                                                ? b?.daily_plan
                                                                      ?.daily_plan_code
                                                                : ""
                                                        }`,
                                                        ...b,
                                                    })
                                                )}
                                                isLoading={batchesLoading}
                                                isClearable={true}
                                                id="select-forms-batches"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="batch"
                                        control={control}
                                    />
                                    {errors.batch && (
                                        <span className="fs-8 text-danger">
                                            Batch is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {/* {isPending ? (
              <button
                type="button"
                id="button-typemaster-loading"
                className="btn btn-md text-dark"
                disabled
              >
                Loading...
              </button>
            ) : ( */}
                                        <button
                                            type="submit"
                                            className="btn btn-md btn-primary"
                                            id="submit-button-create-typemaster"
                                            disabled={!isValid}
                                        >
                                            Submit
                                        </button>
                                        {/* )} */}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default QCReportSelect;
